import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const SettingsPage = lazy(() => import("./SettingsPage"));

const SettingsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SettingsPage />
    </Suspense>
  );
};

export default SettingsPageLazy;
